import { type } from './type.js';

/**
 * @description
 * Checks if `value` is classified as a `Date` object.
 *
 * @example
 * ``` ts
 * isDate(new Date());
 * // => true
 * isDate(Date.now());
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a date object, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-date
 */
export const isDate = (value): value is Date => {
  return type(value) === 'date';
};
